/* src/app/components/layout/home.component.scss */
.container {
  display: flex;
  height: 100%;
}
.container__timers-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  z-index: 1000;
  position: fixed;
  background-color: transparent;
  bottom: 0;
  right: 0;
  left: 0;
  width: fit-content;
  margin: auto;
}
.container__side-bar {
  z-index: 800;
}
.container__nav-bar {
  z-index: 900;
}
.container__nav-bar-and-router-outlet-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}
.container__router-outlet-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #f9faff;
  z-index: 700;
  max-height: 100%;
  overflow: auto;
}
.loader {
  width: 150px;
  height: 48px;
  flex: 0.9;
  margin: 0 auto;
}
@media screen and (max-width: 768px) {
  .container__side-bar {
    display: none;
  }
}
/*# sourceMappingURL=home.component.css.map */
